import { useState } from "react";
import { toast } from "sonner";
import { Smile } from "lucide-react";
import api, { apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";

export const NicknameCard = () => {
  const { user, refresh } = useAuth();
  const [value, setValue] = useState(user?.nickname || "");
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/me/nickname", { nickname: value.trim() });
      toast.success(value.trim() ? `Saved! You'll be known as "${value.trim()}"` : "Nickname cleared");
      refresh();
    } catch (e) {
      toast.error(apiError(e.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  const dirty = (value || "").trim() !== (user?.nickname || "");

  return (
    <div className="card-metal p-5" data-testid="nickname-card">
      <h3 className="font-heading font-black flex items-center gap-2">
        <Smile className="w-5 h-5 text-[#9b111e]" /> Your Personal Nickname
      </h3>
      <p className="text-sm text-slate-500 mt-1">
        Private for now — only shared with a pro/client <b>after you book together</b>, so it feels like you already know each other.
      </p>
      <div className="flex flex-wrap gap-2 items-center mt-3">
        <Input
          value={value}
          onChange={(e) => setValue(e.target.value)}
          maxLength={40}
          placeholder="e.g. Sunny, Ace, Coach K…"
          className="bg-white max-w-xs"
          data-testid="nickname-input"
        />
        <button onClick={save} disabled={saving || !dirty} className={`btn-red-3d !py-2 !px-4 ${(!dirty || saving) ? "opacity-50 cursor-not-allowed" : ""}`} data-testid="nickname-save-btn">
          {saving ? "Saving…" : "Save Nickname"}
        </button>
      </div>
    </div>
  );
};

export default NicknameCard;
